<template lang="pug">
    v-layout.align-center(raw wrap)

        v-flex(xs12 sm6)

            // Program Name field
            v-text-field(
                :error-messages="errors.collect('title')"
                :data-vv-as="$t('fields.title')"
                :label="$t('fields.programName')"
                name="title"
                value="id"
                v-model="model.title"
                v-validate="'required|min:2|max:100'"
                outline
            )

        v-flex(xs12)

            // Assign Meditations
            v-autocomplete(
                :error-messages="errors.collect('meditationIds')"
                :items="sessions"
                :search-input.sync="multiselectSearch"
                :label="$t('fields.meditations')"
                name="meditationIds"
                color="primary"
                append-icon="expand_more"
                deletable-chips
                multiple
                persistent-hint
                small-chips
                outline
                return-object
                item-text="title"
                item-value="id"
                v-model="model.sessions"
                v-validate="'required'"
            )
</template>

<script>
    import { mapFields } from 'vuex-map-fields';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        data() {
            return {
                multiselectSearch: null
            };
        },
        computed: {
            ...mapFields('programs', {
                model: 'program'
            }),
            ...mapGetters('programs', ['isLoading']),
            ...mapGetters('sessions', ['sessions'])
        },
        beforeMount() {
            this.getFlatSessionsAll();
        },
        methods: {
            ...mapActions('sessions', ['getFlatSessionsAll']),

            /**
             * Validate fields on submit
             * @returns {boolean}
             */
            async submit() {
                // Validate all fields and check in no errors
                return await this.$validator.validateAll();
            }
        }
    };
</script>

<style lang="stylus" scoped>
    >>> .v-select__selections
        overflow-x: auto
</style>
